export default __webpack_public_path__ + "static/media/phishing2.7519b382.png";